import React from 'react'
import PropTypes from 'prop-types'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import css from '../../patientCard.css'

const moveFocusToEnd = (e) => {
  const tempVal = e.target.value
  e.target.value = ''
  e.target.value = tempVal
}

const UpdateContact = ({ contactInfo, handleChange, handleSave }) => (
  <form className={css.contactFieldUpdateForm} onSubmit={handleSave}>
    <input
      type="text"
      autoFocus
      className={css.secondaryContactInput}
      onChange={handleChange}
      value={contactInfo || ''}
      onFocus={moveFocusToEnd}
    />
    <button type="submit" className={css.contactIconContainer}>
      <CheckCircle />
    </button>
  </form>
)

UpdateContact.PropTypes = {
  contactInfo: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
}

export default UpdateContact



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/ContactField/EnabledField/UpdateContact.js